import { configVariables as configVars } from "../utils/config";

export function getPlans(){
    return [
        {
            "_id": configVars("comidaSaludableId"), name : "Comida Saludable", description: `Un programa basado en cómo tener una dieta
            completa, equilibrada, y variada. Reemplazos
            saludables a comidas cotidianas que no lo son.`
        },
        {
            "_id": configVars("controlDePesoId"), name : "Control de peso", description: `Tu programa, con especial foco en información y
            consejos para alimentarse equilibradamente y con un
            valor calórico acorde a tu objetivo. Cómo identificar
            alimentos calóricos/grasosos.`
        },
        {
            "_id": configVars("prevencionDeDolenciasId"), name : "Prevención de dolencias", description: `Un plan focalizado en los alimentos que sirven
            para prevenir/ controlar enfermedades como diabetes,
            colesterol, hipertensión, entre otras dolencias.Cómo
            lograr una dieta completa y equilibrada.`
        },
    ]
}